import Vue from "vue"
export default (Vue) => {
    Vue.directive('nextPage', {
        bind(el, binding) {//自定义指令已绑定到dom上就立即执行
            console.log("绑定成功");
            console.log(el.id);//需要监听的元素id
        },
        inserted(el, binding) {//表示页面插入到页面上执行
            console.log("插入成功");
        },
        update(el, binding) {//指令传递的值发生改变
            console.log("更新成功")
        },
        componentUpdated(el, binding) {//组件全部更新
            console.log("全部更新成功");
        },
        unbind(el, binding) {//只调用一次，指令于元素解绑时调用
            console.log("解绑成功");
        }
    })
}